import { Field } from '@progress/kendo-react-form';
import React, { useState, useEffect} from 'react'; 
import { CusFormComboBox, CusFormInput } from '../validation/Form-Components';
import taxData from '../data/taxdetailsdata.json'
import { reqDDLValidator, taxReasonValidator, tinRNoValidator, tinValidator } from '../validation/Validators';
import { filterBy } from "@progress/kendo-data-query";

let filteredCountry;
const TaxResidence = (props) => {
    const{ order ,fProps, show,...oth} = props;

    const [showReasonUnableProvTIN,setShowReasonUnableProvTIN] = useState(show);
    const [fCountries, setfCountries] = useState(oth.array.slice());
   
    filteredCountry = oth.array.slice();

    useEffect(() => {
        console.log('@TaxResidence useEffect');
    }, []);

    const handleCouOfTaxRes = (e)=> {
      
        props.onCouOfTaxResChange(e.value);
    }

    const filterData = (filter) => {
        let secData, firstData;
        if(order === 2) {
            firstData = oth.array;
            return filterBy(firstData, filter);
        }
        else {
            secData = oth.array;
            return filterBy(secData, filter);
        }
    };
    
    const handleFilterChange = (event) => {
        filteredCountry = filterData(event.filter);
        setfCountries(filterData(event.filter));
    }
    
    return(
    <div id={order}>
    <Field leftLabelId={'lblCnOfResi'+order} leftLabelName={taxData.label.cnOfTaxResi2}
        id={'CouOfTaxRes'+order} name={'CouOfTaxRes'+order}
        component={CusFormComboBox}
        textField={'label'}
        data={fCountries}
        placeholder={'Please select'}
        validator={reqDDLValidator}
        onChange={handleCouOfTaxRes}
        filterable={true}
        onFilterChange={handleFilterChange} /> 
        
    <Field leftLabelId={'lblCnOfResi'+order} leftLabelName={taxData.label.ableTIN}
        id={'AbleProvTIN'+order} name={'AbleProvTIN'+order}
        component={CusFormComboBox}
        textField={'label'}
        data={taxData.ableToProvideTinDDL.data}
        placeholder={'Please select'}
        validator={reqDDLValidator}
        onChange={ e =>{
            if(e.value === null){
                return;
            }
            let reasonCode = e.value;
            if(reasonCode.value === taxData.ableToProvideTinDDL.data[2].value){
                setShowReasonUnableProvTIN(true);
            }
            else{
                setShowReasonUnableProvTIN(false);
            }
            fProps.onChange('ReasonUnableProvTIN'+order, { value: '' });
        }} /> 
    
    <Field component={CusFormInput} 
        leftLabelId={'lblTaxNumber'+order} leftLabelName={taxData.label.taxIN} maxLength={20}
        id={'TaxNumber'+order} name={'TaxNumber'+order} placeholder={'Please input'} 
        validator={fProps.valueGetter('AbleProvTIN'+order) !== undefined && fProps.valueGetter('AbleProvTIN'+order) !== null ? fProps.valueGetter('AbleProvTIN'+order).value === 'Y'? tinValidator:tinRNoValidator:''} />

    {showReasonUnableProvTIN? 
        <Field component={CusFormInput} 
        leftLabelId={'lblRsnUnableProvTin'+order} leftLabelName={taxData.label.whyUnableTIN} 
        id={'ReasonUnableProvTIN'+order} name={'ReasonUnableProvTIN'+order} 
        placeholder={'Please input'} 
        maxLength={100} 
        validator={taxReasonValidator} />: null
    }

    </div>
    )
}

export default TaxResidence;